import React from 'react';

function LastVisitedPreview() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="108"
      viewBox="0 0 108 108"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path fill="#FFF" d="M0 0H108V108H0z" />
        <path
          fill="#EFEFEF"
          d="M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
        />
        <rect width="31" height="31" x="39" y="38" fill="currentColor" rx="4" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M55.143 59.988a.95.95 0 00.785-.92v-7.037h4.61c.231 0 .462-.222.462-.443a.4.4 0 00-.187-.36l-.008-.006-5.158-4.958c-.331-.352-.922-.352-1.296 0l-5.21 5c-.15.144-.18.303-.093.49.05.166.23.263.425.263h4.611v7.08c0 .539.511.981 1.059.891z"
          transform="rotate(-90 55 53)"
        />
      </g>
    </svg>
  );
}

export default LastVisitedPreview;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/LastVisitedPreview.js